var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.name + "__title")},[_vm._t("title",function(){return [_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]})],2),_vm._v(" "),_c('div',{class:[("" + _vm.name), ("" + _vm.containerClass)]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }